import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';

const CostCategoryDeleteModal = ({ setModalVisible, costCategoryId, onClickDeleteCategory }) => {
  const { t } = useTranslation();
  const onClose = () => setModalVisible(false);
  const onDelete = () => {
    onClickDeleteCategory(costCategoryId);
    setModalVisible(false);
  };

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: t(translations.costSetup_deleteCostCategory),
          content: <>{t(translations.costSetup_areYouSureYouWantToDeleteThisCategory)}</>,
          footer: (
            <>
              <Button testId="delete-modal-button-delete" label={t(translations.delete)} colored onClick={onDelete} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

export { CostCategoryDeleteModal };
